import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { context } from "../../context/authContext";
import Dropdown from "react-bootstrap/Dropdown";
import "./Navigation.css";

export default function Navigation() {
    const [menuLeft, setMenuLeft] = useState(false);
    const { handleLogout, user } = useContext(context);

    const handleOpenMenu = () => setMenuLeft(true);
    const handleCloseMenu = () => setMenuLeft(false);

    return (
        <header>
            <nav className="navbar navbar-light navbar-bg-dark d-flex justify-content-between">
                <button className="btn btn-outline-grey" onClick={handleOpenMenu}>
                    <i className="fas fa-bars"></i> Menú
                </button>
                <div className="logo">
                    <Link to="https://kloudlab.ar"><img src='../../../img/logo-kloudlab-v01.png' alt="" /></Link>
                </div>
                <Dropdown>
                    <Dropdown.Toggle variant="outline-grey">
                        {user.email || "Usuario"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleLogout}>Cerrar Sesión</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </nav>

            {
                menuLeft && (
                    <div className="collapse-menu">
                        <div className="collapse-menu-content">
                            <div className="close">
                                <button onClick={handleCloseMenu}>
                                    <i className="fas fa-times mr-1"></i> <b>Cerrar menú</b>
                                </button>
                            </div>
                            <ul className="content">
                            {user.rol.map(item =>{
                                if(item.permiso.includes("ver")){
                                    return (
                                        <li key={item.nombre} className="mb-3">
                                            <Link to={item.ruta} onClick={handleCloseMenu} >
                                                {item.nombre}
                                            </Link>
                                        </li>
                                    )
                                }else return null
                            })}
                            </ul>
                            <a className="text-white" href="https://kloudlab.ar"><span className="ps-3 pb-2">Powered by Kloudlab</span></a>
                        </div>
                    </div>
                )
            }
        </header>
    );
}
